import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import et from 'vuetify/src/locale/et'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { et },
    current: 'et'
  },
  icons: {
    iconfont: 'md'
  },
  options: {
    customProperties: true
  },
  theme: {
    themes: {
      light: {
        primary: '#cd5a07',
        secondary: '#efa72b',
        accent: '#560031',
        error: '#FF5252',
        info: '#72002f',
        success: '#4CAF50',
        warning: '#FFC107',
        priority: {
          low: colors.lightGreen.base,
          normal: colors.orange.base,
          high: colors.red.base,
          critical: colors.red.darken4
        }
      }
    }
  }
})
